import React, { useState, useEffect } from 'react';
import KeyboardArrowUpOutlinedIcon from '@mui/icons-material/KeyboardArrowUpOutlined';
import './style.css';

export default function ScrollPage() {
  const [showButton, setShowButton] = useState(false);

  function topFunction() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  useEffect(() => {
    function handleScroll() {
      setShowButton(window.scrollY >= window.innerHeight-100);
    }

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []); // Empty dependency array means this effect runs once on mount

  return (
    <div className={showButton ? 'topBtn' : 'topBtn hidden'}>
      <KeyboardArrowUpOutlinedIcon onClick={topFunction} sx={{ color:'#1976D2'  }}/>
    </div>
  );
}
